let config = null

// Cool INFO: So half the configs come from config.json as u expected
// Rest of the credential configurations (like google client id, etc) come directly from Auth Service
// Our API backend acts as a middleman, communicating with Auth Service, to get us the data
//
// We only keep the in-memory 'config' variable for the lifetime of the page -
// no localStorage caching, so a failed/incomplete provider-data fetch (e.g. missing
// googleClientId) can't get stuck across reloads; every fresh page load re-fetches.
export async function loadConfig() {
  if (config) return config

  const res = await fetch('/config.json')
  if (!res.ok) throw new Error(`Failed to load config.json: ${res.status}`)

  config = await res.json()

  const { baseUrl } = config
  if (!baseUrl) throw new Error('Config is missing baseUrl')

  try {
    const providerRes = await fetch(`${baseUrl}/internal/provider-data`)
    if (!providerRes.ok)
      throw new Error(`Provider data fetch failed: ${providerRes.status}`)

    const providers = await providerRes.json()

    providers?.data?.forEach(({ provider, config: cfg }) => {
      if (!cfg) return

      if (provider === 'MICROSOFT') {
        config.azureClientId = cfg.client_id
        config.azureTenantId = cfg.tenant_id
      } else if (provider === 'GOOGLE') {
        config.googleClientId = cfg.client_id
      }
    })
  } catch (err) {
    console.error('Failed to load provider data:', err)
  }

  return config
}

export function getConfig() {
  if (!config) throw new Error('Config not loaded. Call loadConfig() first.')
  return config
}
